export enum EWebimActions {
  setVisibleChat = 'webim/setVisibleChat',
  toggleVisibleInformer = 'webim/toggleVisibleInformer',
}
